import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert } from 'react-bootstrap';

import MainBlockContainer from '../../MainBlockContainer';
import MainBlockHeader from '../../MainBlockHeader';
import Loading from '../../../components/Shared/Loading';
import TrendCharts from '../../../components/Shared/Trends/TrendCharts';

import api from '../../../services/api';

export default function Trends() {
  const { consultationUid } = useParams();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [trendData, setTrendData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(`/consultation/expert/accepted/${consultationUid}/user/trends`)
      .then((response) => {
        setTrendData(response.data);
        setLoading(false);
      })
      .catch(() => {
        setError(t('messages.loadError'));
        setLoading(false);
      });
  }, [consultationUid]);

  return (
    <>
      <MainBlockHeader header={t('trends.header')} />
      <MainBlockContainer>
        {loading && <Loading />}
        {error && <Alert variant="danger">{error}</Alert>}
        {!loading && !error && <TrendCharts data={trendData} />}
      </MainBlockContainer>
    </>
  );
}
